import get from 'lodash.get';
import uniq from 'lodash.uniq';
import { sortByPredefinedOrder } from '../shared/sortUtils';
import { getStudentResultsByMeasureYearGradePeriod } from '../shared/filterUtils';
import { getMeasuresByGrade } from '../shared/gradeToMeasureUtils';
import { getLicensedMeasures } from './filterUtils';
import {
    PM_MEASURES_EXCEPTIONS,
    MEASURES_KEYS,
    BURST_MEASURES,
    MEASURE,
} from '../../constants/reading/MeasuresConstants';
import { PERIOD } from '../../constants/shared/CommonConstants';

const { LEXILE } = MEASURE;

export const getStudentDataByMeasures = (
    studentStatuses,
    interps,
    grade,
    year,
    licensingInfo,
    studentGoals,
    selectedStudentId,
    gradeToMeasureMapper,
    summerPeriodLabel,
) => {
    const measuresByGrade = getMeasuresByGrade(gradeToMeasureMapper, grade);
    const studentStatusesByGradeYear = getStudentResultsByMeasureYearGradePeriod(
        studentStatuses,
        null,
        year,
        grade,
    ).filter(status => status.measure !== LEXILE);
    const studentGoalsByGradeYear = getStudentResultsByMeasureYearGradePeriod(
        get(studentGoals, `${selectedStudentId}`, []),
        null,
        year,
        grade,
    );
    const assessedMeasures = studentStatusesByGradeYear.map(status => status.measure);
    const availableMeasures = uniq(
        [...measuresByGrade, ...assessedMeasures].filter(
            measure => !PM_MEASURES_EXCEPTIONS.includes(measure),
        ),
    );
    const measureList = sortByPredefinedOrder(
        getLicensedMeasures(availableMeasures, licensingInfo),
        [...MEASURES_KEYS, ...BURST_MEASURES],
    );
    const dataByMeasure = measureList.map(measure => {
        const gradeYearResults = studentStatusesByGradeYear
            .filter(status => status.measure === measure)
            .map(status => ({
                ...status,
                periodLabel: status.period === PERIOD.SUMMER ? summerPeriodLabel : status.period,
            }));
        const interpsByMeasureGrade = getStudentResultsByMeasureYearGradePeriod(
            interps,
            measure,
            null,
            grade,
        );
        const studentGoalsByMeasure = studentGoalsByGradeYear.filter(
            status => status.measure === measure,
        );
        return {
            measure,
            statuses: gradeYearResults,
            interps: interpsByMeasureGrade,
            goals: studentGoalsByMeasure,
            isMeasureLicensedInGrade: measuresByGrade.includes(measure),
        };
    });

    return {
        grade,
        year,
        dataByMeasure,
    };
};

export default getStudentDataByMeasures;
